import { render, staticRenderFns } from "./DashboardTreeCategory.vue?vue&type=template&id=8f419dee&scoped=true"
import script from "./DashboardTreeCategory.vue?vue&type=script&lang=js"
export * from "./DashboardTreeCategory.vue?vue&type=script&lang=js"
import style0 from "./DashboardTreeCategory.vue?vue&type=style&index=0&id=8f419dee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f419dee",
  null
  
)

export default component.exports